// Single source of truth for the forwarding subdomain. The singleton config
// getter passes it to the client, and the service builds alias addresses
// (`{aliasName}@{EMAIL_FORWARDING_DOMAIN}`) from it. If we ever change
// subdomains, this is the only line that has to flip.
export const EMAIL_FORWARDING_DOMAIN = "expert.terac.com";

// Audit copy: every alias also forwards to a plus-addressed mailbox we own so
// we can read the actual email bodies (Forward Email's REST API doesn't expose
// forwarded message contents).
export const EXPERT_INBOUND_LOCAL = "expert-inbound";
export const EXPERT_INBOUND_DOMAIN = "terac.com";

export function buildExpertInboundRecipient(aliasName: string): string {
  return `${EXPERT_INBOUND_LOCAL}+${aliasName}@${EXPERT_INBOUND_DOMAIN}`;
}
